import React from 'react';

import { Card, CardContent, Grid, Typography } from '@mui/material';
import { COLOR_GREY_600 } from 'src/colors';

const DataChartTooltip = ({
  data,
}: {
  data: { dataKey: string; val: string; color: string }[];
}) => {
  return (
    <Card sx={{ boxShadow: `0px 0px 10px 0px ${COLOR_GREY_600}` }}>
      <CardContent sx={{ marginBottom: -2, padding: 1 }}>
        {data.map(data => (
          <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
            <Typography
              variant="caption"
              sx={{ color: COLOR_GREY_600, fontWeight: 500, paddingRight: 1 }}
            >
              {data.dataKey}:
            </Typography>
            <Typography variant="body2" sx={{ color: data.color, fontWeight: 500 }}>
              {data.val}
            </Typography>
          </Grid>
        ))}
      </CardContent>
    </Card>
  );
};

export default DataChartTooltip;
